import React from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import { get } from "lodash";
import { PrimaryBorrower } from "./components/PrimaryBorrower";
import { ContinueButton } from "../../../../../../components/Buttons/ContinueButton";
import { ButtonWrapper } from "./styled";

export const CompanyBankingRelationshipsComponent = ({ handleContinue, orgKYCDetails }) => {
  const otherBankLoanExist = get(
    orgKYCDetails,
    "otherBankingRelationshipsInfo.otherBankLoanExist",
    false
  );
  return (
    <Grid container spacing={3}>
      <Grid item sm={12} xs={12}>
        <h5>Banking Relationship Primary Borrower</h5>
        {otherBankLoanExist &&
        orgKYCDetails.otherBankingRelationshipsInfo.otherBankLoanRelationship &&
        orgKYCDetails.otherBankingRelationshipsInfo.otherBankLoanRelationship.length > 0 ? (
          <PrimaryBorrower
            handleContinue={handleContinue}
            otherBankLoanRelationships={
              orgKYCDetails.otherBankingRelationshipsInfo.otherBankLoanRelationship
            }
          />
        ) : (
          <h6>Primary borrowers are not found</h6>
        )}
      </Grid>
      <ButtonWrapper>
        <ContinueButton onClick={handleContinue} type="submit" />
      </ButtonWrapper>
    </Grid>
  );
};

CompanyBankingRelationshipsComponent.propTypes = {
  /**
   * Function to handle form submission and continue to next step
   */
  handleContinue: PropTypes.func.isRequired,

  /**
   * Organization KYC details containing banking relationship information
   */
  orgKYCDetails: PropTypes.shape({
    otherBankingRelationshipsInfo: PropTypes.shape({
      otherBankLoanExist: PropTypes.bool,
      otherBankLoanRelationship: PropTypes.arrayOf(
        PropTypes.shape({
          bankName: PropTypes.string,
          facilityType: PropTypes.string,
          facilityAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          outstandingAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          currency: PropTypes.string,
          monthlyInstallment: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          pending: PropTypes.bool
        })
      )
    })
  })
};
